var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 800,
    viewBox: "-13.2 -16.50405 114.4 99.0243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M6 66.0162h14v-34l-20-15v43c0 3.315 2.685 6 6 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M68 66.0162h14c3.315 0 6-2.685 6-6v-43l-20 15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc04",
    d: "M68 6.0162v26l20-15v-8c0-7.415-8.465-11.65-14.4-7.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M20 32.0162v-26l24 18 24-18v26l-24 18z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5221f",
    d: "M0 9.0162v8l20 15v-26l-5.6-4.2c-5.935-4.45-14.4-.215-14.4 7.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.456e473acdfa595d925a91ae744cc16d.svg";
export { ForwardRef as ReactComponent };